var $2d6cd3e34084f444$exports = {};
$2d6cd3e34084f444$exports = {
    "more": `Tov\xe1bbi elemek`
};


export {$2d6cd3e34084f444$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
